export default "__VITE_ASSET__9aad3e96__"